import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (this.filters.advanced.name !== null) {
      params.set("name", this.filters.advanced.name);
    }

    if (this.filters.advanced.foundWay !== null) {
      params.set("foundWay", this.filters.advanced.foundWay);
    }

    if (this.filters.advanced.status !== null) {
      params.set("status", this.filters.advanced.status);
    }

    if (this.filters.advanced.company.length > 0) {
      this.filters.advanced.company.forEach((element) =>
        params.append("companies", element.id)
      );
    }

    if (
      this.filters.advanced.date != null &&
      this.filters.advanced.date.length > 0
    ) {
      const startDate = this.filters.advanced.date[0];
      const endDate = this.filters.advanced.date.at(-1);

      params.set("startDate", formatDateToIsoString(new Date(startDate)));
      params.set("endDate", formatDateToIsoString(new Date(endDate)));
    }

    if (this.filters.advanced.workingHours !== null) {
      params.set("workingHours", this.filters.advanced.workingHours);
    }

    if (this.filters.advanced.parentLocation !== null) {
      params.set("parentLocation", this.filters.advanced.parentLocation.id);
    }

    if (this.filters.advanced.location !== null) {
      params.set("location", this.filters.advanced.location.id);
    }

    if (this.filters.advanced.contractType !== null) {
      params.set("contractType", this.filters.advanced.contractType);
    }

    if (
      this.filters.advanced.workingShifts !== null &&
      this.filters.advanced.workingShifts.length
    ) {
      this.filters.advanced.workingShifts.forEach((shift) => {
        params.append("workingShifts", shift);
      });
    }

    if (this.filters.advanced.workWeekSchedule !== null) {
      params.set("workWeekSchedule", this.filters.advanced.workWeekSchedule);
    }

    if (this.filters.advanced.salaryRange !== null) {
      params.set("salaryRange", this.filters.advanced.salaryRange);
    }

    if (this.filters.advanced.previousExperience !== null) {
      params.set(
        "previousExperience",
        this.filters.advanced.previousExperience
      );
    }

    if (this.filters.advanced.gender !== null) {
      params.set("gender", this.filters.advanced.gender);
    }

    if (this.filters.advanced.age !== null) {
      params.set("age", this.filters.advanced.age);
    }

    if (this.filters.advanced.drivingLicense !== null) {
      params.set("drivingLicense", this.filters.advanced.drivingLicense);
    }

    if (this.filters.advanced.offersTraining !== null) {
      params.set("offersTraining", this.filters.advanced.offersTraining);
    }

    if (this.filters.advanced.contactWhatsapp !== null) {
      params.set("contactWhatsapp", this.filters.advanced.contactWhatsapp);
    }

    if (this.filters.advanced.openToPwD !== null) {
      params.set("openToPwD", this.filters.advanced.openToPwD);
    }

    if (this.filters.advanced.offersTransportation !== null) {
      params.set("offersTraining", this.filters.advanced.offersTransportation);
    }

    if (this.filters.advanced.responsible !== null) {
      params.set("responsible", this.filters.advanced.responsible.id);
    }

    if (this.filters.advanced.branch !== null) {
      params.set("branch", this.filters.advanced.branch);
    }

    return params;
  },
};
